import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { LabCase } from "../../Cases/case";
import { fuseAnimations } from "@fuse/animations";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "app/main/module/common/service/api.service";
import { statusType, Tickets } from "../tickets";
import { FormControl, FormGroup } from "@angular/forms";
import { AddTicketsComponent } from "../add-tickets/add-tickets.component";
import { Globals } from "app/main/module/common/global";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import { TableRefreshService } from "../table-refresh.service";
import { Subscription } from "rxjs";
import { TicketsService } from "../tickets.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { EditTicketComponent } from "../edit-ticket/edit-ticket.component";
import { TicketDataService } from "../ticket-data.service";
import * as moment from "moment";

@Component({
    selector: "app-tickets-list",
    templateUrl: "./tickets-list.component.html",
    styleUrls: ["./tickets-list.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class TicketsListComponent implements OnInit, OnDestroy, AfterViewInit {
    displayedColumns = [];
    columns: any[] = [];
    page: number;
    perPage: number;
    allTicket: Tickets[] = [];
    allTicketData: Tickets[] = [];
    dataSource = new MatTableDataSource<any>(this.allTicketData);
    dataSourceFilters = new MatTableDataSource(this.allTicketData);
    dataSourceWithPageSize = new MatTableDataSource(this.allTicketData);
    isInitComplete: Boolean = false;
    searchText: string = "";
    isLoading: Boolean = false;
    selectedStatus: string = "";
    next: number = 1;
    prev: number = 0;
    isNextPressed: boolean = false;
    count: number = 0;
    totalPage: boolean = false;
    range: FormGroup;
    private subscription!: Subscription;
    isSearch: boolean = false;
    labTimeZone: any;
    isFilterByDateRange: Boolean = false;
    startTimestamp: string;
    endTimestamp: string;
    role: any;
    statusList = statusType;
    routerSubscription: Subscription;
    detailPagePath = "/tickets/ticket-details";
    currentPagePath = "/tickets/tickets-list";
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;
    searchDisabled: boolean = false;

    constructor(
        public translate: TranslateService,
        private apiService: ApiService,
        public dialog: MatDialog,
        public global: Globals,
        private router: Router,
        private tableRefreshService: TableRefreshService,
        public ticketService: TicketsService,
        public snackbar: MatSnackBar,
        public ticketDataService: TicketDataService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        this.selectedStatus =
            localStorage.getItem("ticketSelectedStatus") || "all";
    }

    ngOnInit(): void {
        this.labTimeZone = localStorage.getItem("defaultTz");
        this.role = localStorage.getItem("role");
        const keys = [
            "Common.Sr",
            "Tickets.ticketId",
            "Tickets.title",
            "Tickets.typeOfEquipment",
            "Tickets.severity",
            "Tickets.status",
            "Tickets.createdOn",
            "Tickets.assignedTo",
            "Tickets.resolvedOn",
            "Tickets.action",
        ];

        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        this.range = new FormGroup({
            start: new FormControl(),
            end: new FormControl(),
        });

        this.dataSource.data = [];
        this.allTicketData = [];
        this.isLoading = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.subscription = this.tableRefreshService.refresh$.subscribe(() => {
            this.loadTableData();
        });
        this.getAllData(1);
        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (
                    !event.url.includes(this.detailPagePath) &&
                    !event.url.includes(this.currentPagePath)
                ) {
                    localStorage.removeItem("ticketSelectedStatus");
                }
            }
        });
        this.selectedStatus =
            localStorage.getItem("ticketSelectedStatus") || "all";
    }

    getAllData(page: number, startTimestamp?: string, endTimestamp?: string) {
        this.isInitComplete = true;
        this.totalPage = false;
        this.searchDisabled = false;
        this.perPage = 10;
        let search = (this.searchText = "");
        this.ticketService
            .getTickets(
                page,
                this.perPage,
                search,
                startTimestamp,
                endTimestamp,
                this.selectedStatus,
            )
            .subscribe(
                (response: any) => {
                    if (response.message == "No data Found") {
                        this.totalPage = true;
                        this.isInitComplete = false;
                    }
                    if (response && response.data.length > 0) {
                        this.allTicket = response.data;
                        this.allTicketData.push(...this.allTicket);
                        this.dataSource.data = this.allTicketData;
                        this.isInitComplete = false;
                        this.hasMoreData =
                            this.allTicket.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }
                        // console.log("Fetched cases:", this.allTicketData);
                    } else {
                        this.allTicket = [];
                        this.isInitComplete = false;
                        // console.log("Inside else");

                        this.openSnackBar(
                            this.translateSentence("Common.noDataFound"),
                            this.translateSentence("Common.ok"),
                        );
                    }
                },
                (error) => {
                    console.error("Error fetching cases:", error);
                    this.totalPage = true;
                    this.isInitComplete = false;
                    let errorMessage = error.error.message;
                    this.openSnackBar(
                        errorMessage,
                        this.translateSentence("Common.ok"),
                    );
                },
            );
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "SrCasessette",
                header: translations["Common.Sr"],
                cell: (element: Tickets, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "ticketId",
                header: translations["Tickets.ticketId"],
                cell: (element: Tickets, index: number) =>
                    element.ticket_id || "",
            },
            {
                columnDef: "Title",
                header: translations["Tickets.title"],
                cell: (element: Tickets, index: number) => element.title || "",
            },
            {
                columnDef: "typeOfEquipment",
                header: translations["Tickets.typeOfEquipment"],
                cell: (element: Tickets, index: number) =>
                    element.type_of_equipment ? element.type_of_equipment : "",
            },
            {
                columnDef: "severity",
                header: translations["Tickets.severity"],
                cell: (element: Tickets, index: number) =>
                    this.translateSentence(`Tickets.${element.severity}`) || "",
            },
            {
                columnDef: "createdOn",
                header: translations["Tickets.createdOn"],
                cell: (element: Tickets, index: number) =>
                    element.created_on
                        ? this.changeDate(element.created_on)
                        : "-",
            },
            {
                columnDef: "assignedTo",
                header: translations["Tickets.assignedTo"],
                cell: (element: Tickets, index: number) =>
                    this.capitalizeFirstLetter(element.assigned_to[0]?.name),
            },
            {
                columnDef: "resolvedOn",
                header: translations["Tickets.resolvedOn"],
                cell: (element: Tickets, index: number) =>
                    element.resolved_on
                        ? this.changeDate(element.resolved_on)
                        : "-",
            },
            {
                columnDef: "status",
                header: translations["Tickets.status"],
                cell: (element: Tickets, index: number) =>
                    this.translateSentence(`Tickets.${element.status}`),
                // textColor: (element: Tickets, index: number) => {
                //     return this.getColourByStatus(element.status);
                // },
            },
            {
                columnDef: "action",
                header: translations["Tickets.action"],
                cell: (element: Tickets, index: number) => {
                    // const key = `LabCases.${element.status}`;
                    // return this.translateSentence(key);
                },
            },
        ];
    }

    changeDate(date): any {
        // // // console.log(e);
        var timestamp = parseInt(date);
        return (date = this.apiService.getDateStringMomentByTz(timestamp));
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    getRowBackgroundColor(element): string {
        return "#FFFFFF";
    }

    getRowFontStyle(element) {
        if (element.status == "completed") {
            return "italic";
        } else return "bold";
    }

    getFontColor(element) {
        return "#000000";
    }

    openAddTicketDialog(): void {
        const dialogRef = this.dialog.open(AddTicketsComponent, {
            panelClass: "ref-dialog",
            disableClose: true,
            width: "525px",
            maxHeight: "90vh",
            data: {},
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    openEditCaseDialog(row): void {
        const dialogRef = this.dialog.open(EditTicketComponent, {
            disableClose: true,
            width: "525px",
            data: { id: row.id },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    loadTableData() {
        this.dataSource.data = [];
        this.allTicketData = [];
        this.allTicket = [];
        this.isLoading = true;
        this.hasMoreData = true;
        this.isNextPressed = false;
        this.isSearch = false;
        this.isFilterByDateRange = false;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.range.reset();
        this.selectedStatus = "all";
        this.startTimestamp = "";
        this.endTimestamp = "";
        localStorage.setItem("ticketSelectedStatus", this.selectedStatus);
        this.getAllData(1);
    }

    openSnackBar(message: string, action: string): void {
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }

    onNextPress() {
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        if (this.isSearch) {
            this.onClickSearch(this.searchText);
        } else if (this.isFilterByDateRange) {
            this.getAllData(this.next, this.startTimestamp, this.endTimestamp);
        } else {
            this.getAllData(this.next);
        }
    }

    viewTicketDetails(ticket: any) {
        this.ticketDataService.setTicket(ticket.id, ticket);
        this.router.navigate(["/tickets/ticket-details"], {
            queryParams: { ticket_id: ticket.id },
        });
    }

    onSearchInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.searchText = input.value.toUpperCase();
    }

    onClickSearch(searchText) {
        this.isInitComplete = true;
        this.searchDisabled = true;
        this.perPage = 10;
        this.searchText = searchText.trim();
        this.isLoading = true;
        this.isSearch = true;
        // console.log("searchText: ", searchText);

        this.ticketService
            .getTickets(this.next, this.perPage, this.searchText)
            .subscribe(
                (a) => {
                    Object.entries(a).find(([key, value]) => {
                        if (key == "message" && value == "No data Found") {
                            this.totalPage = true;
                            this.isInitComplete = false;
                            this.searchDisabled = false;
                        }
                        if (key == "data") {
                            this.isInitComplete = false;
                            this.allTicket = Array.isArray(value)
                                ? (value as Tickets[])
                                : [];
                            this.hasMoreData =
                                this.allTicket.length === this.PAGE_SIZE;
                            if (!this.hasMoreData && this.isNextPressed) {
                                this.openSnackBar(
                                    this.translateSentence(
                                        "Common.noFurtherDataAvailable",
                                    ),
                                    this.translateSentence("Common.ok"),
                                );
                            }
                            this.searchDisabled = false;
                            // console.log("value:", value);
                        } else if (key == "status" && value == "failed") {
                            this.isLoading = false;
                            this.isInitComplete = false;
                            this.searchDisabled = false;
                            this.openSnackBar(
                                this.translateSentence("Common.noDataFound"),
                                this.translateSentence("Common.ok"),
                            );
                        }
                    });
                    this.allTicketData.push(...this.allTicket);
                    this.dataSource.data = this.allTicketData;
                },
                (err) => {
                    this.isInitComplete = false;
                    this.searchDisabled = false;
                    this.openSnackBar(err.error.message, "Ok");
                },
            );
    }

    handleSearchTicket(searchText: string) {
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
            return;
        }
        this.next = 1;
        this.prev = 0;
        this.totalPage = false;
        this.allTicket = [];
        this.allTicketData = [];
        this.dataSource.data = [];
        this.range.reset();
        this.startTimestamp = "";
        this.endTimestamp = "";
        this.selectedStatus = "all";
        localStorage.setItem("ticketSelectedStatus", this.selectedStatus);
        this.onClickSearch(searchText);
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.searchText.length === 1) {
            this.searchText = "";
            this.searchDisabled = true;
            this.loadTableData();
            this.isSearch = false;
        }
    }

    clearInputSearch() {
        this.searchText = "";
        this.selectedStatus = "all";
        this.searchDisabled = true;
        localStorage.setItem("ticketSelectedStatus", this.selectedStatus);
        this.loadTableData();
        this.isSearch = false;
    }

    filterTicketByDateRange() {
        const startDate = this.range.value.start;
        const endDate = this.range.value.end;
        this.isFilterByDateRange = true;
        this.dataSource.data = [];
        this.allTicket = [];
        this.allTicketData = [];
        this.next = 1;
        this.page = 0;
        this.prev = 0;
        this.isSearch = false;

        if (startDate && endDate) {
            this.startTimestamp = moment(startDate)
                .tz(this.labTimeZone)
                .valueOf()
                .toString();

            this.endTimestamp = moment(endDate)
                .endOf("day")
                .tz(this.labTimeZone)
                .valueOf()
                .toString();
        }
        if (startDate && endDate) {
            this.getAllData(this.next, this.startTimestamp, this.endTimestamp);
        }
    }

    capitalizeFirstLetter(word: string): string {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    resetDateRange(): void {
        this.startTimestamp = "";
        this.endTimestamp = "";
        this.loadTableData();
    }

    filterTicketsByStatus() {
        this.dataSource.data = [];
        this.allTicket = [];
        this.allTicketData = [];
        this.isSearch = false;
        this.isFilterByDateRange = true;
        this.next = 1;
        this.page = 0;
        this.prev = 0;
        localStorage.setItem("ticketSelectedStatus", this.selectedStatus);
        this.getAllData(this.next, this.startTimestamp, this.endTimestamp);
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
